document.addEventListener("DOMContentLoaded", (event) => {
  if(window.location.search.includes('open-monogram=true')) {
    setTimeout(function() {
      document.querySelector('.add-monogram.modal-action').dispatchEvent(new Event('click'));
    },2000);
  }
  $('.rg-subcollections').slick({

    // normal options...
    infinite: false,
    slidesToShow: 6,

    // the magic
    responsive: [{

      breakpoint: 1700,
      settings: {
        slidesToShow: 5,
      }

    },{

      breakpoint: 1300,
      settings: {
        slidesToShow: 4,
      }

    },,{

      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
      }

    },{

      breakpoint: 768,
      settings: {
        dots: true,
        slidesToShow: 3,
      }

    }, {

      breakpoint: 300,
      settings: "unslick" // destroys slick

    }]
  });
});
